import { render, staticRenderFns } from "./AddUpdateShare.vue?vue&type=template&id=2670bff8&scoped=true"
import script from "./AddUpdateShare.vue?vue&type=script&lang=js"
export * from "./AddUpdateShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670bff8",
  null
  
)

export default component.exports